import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * File service class containing all methods to retrieve files
 */
class FileService {
  static getFiles(limit = 10, page = 1, filter) {
    let apiUrl = `${API.URL + API.FILES}?pageSize=${limit}&page=${page}`

    if (filter) {
      apiUrl += `&filterImage=${encodeURIComponent(filter)}`
    }

    return ApiHelper.fetch(apiUrl)
  }

  static getFile(id) {
    return ApiHelper.fetch(`${API.URL + API.FILES}/${id}`)
  }

  static thumbnailLink(id) {
    return `${API.URL + API.FILES}/${id}/thumb`
  }

  static findImages(filter = '', limit = 20, page = 1) {
    return ApiHelper.fetch(
      `${API.URL + API.FILES}?pageSize=${limit}&page=${page}&filterImage=${filter}`
    )
  }

  static addFile(formdata) {
    return ApiHelper.fetch(`${API.URL + API.FILES}`, {
      method: 'POST',
      body: formdata,
      headers: new Headers()
    })
  }

  static deleteFile(id) {
    return ApiHelper.fetch(`${API.URL + API.FILES}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default FileService
